import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

export const SOCIAL_NETWORKS_ICONS = {
  discord: FA_ICONS.DISCORD,
  twitch: FA_ICONS.TWITCH,
  facebook: FA_ICONS.FACEBOOK_F,
  youtube: FA_ICONS.YOUTUBE,
  twitter: FA_ICONS.TWITTER,
  instagram: FA_ICONS.INSTAGRAM,
  xbox: FA_ICONS.XBOX,
}

export const JUDGE_ROUNDS = {
  all: 'All Rounds',
  qualification: 'Qualification Round',
  evaluation: 'Evaluation Round',
  runoff: 'Run-off Round',
  final: 'Final Round',
  standby: 'Standby',
}

export const TOP_15_ROUND = 'top 15'
export const TOP_10_ROUND = 'top 10'
export const FINAL_ROUND = 'final'
export const TIEBREAKER_ROUND = 'tiebreaker'
export const JUDGE_TOP_ROUNDS = {
  [TOP_15_ROUND]: 'Top 15, Top 10, Winners!',
  [TOP_10_ROUND]: 'Top 10, Winners!',
}

export const JUDGE_STATUSES = {
  judge: 'Judge',
  admin: 'Contest Admin',
}
export const ORIGINAL_MAPS_USER_ID_BY_ENV = {
  development: 91668,
  production: 92073,
  test: 92039,
}
